import {toast} from "react-toastify";

export function toastAsError(message: string, title: string = 'Errore!') {
    // https://fkhadra.github.io/react-toastify/render-what-you-want
    toast(({closeToast}) => {
        return (<div>{title} <br/> {message} </div>)
    }, {type: 'error'})
}